import * as React from 'react';
import useReduxState from 'src/hooks/useReduxState';

const ContactUsPlaceOrderPopup = (props) => {
    const { SetStatus, data } = props;
    const [isPaymentBlocked, setIsPaymentBlocked] = useReduxState('', 'setIsPaymentBlocked');
    return (
        <>
            <div className="avnet-modal modal-375">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => {
                            setIsPaymentBlocked('close')
                            SetStatus(false)
                        }}>×
                    </button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5">Contact Us</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body py-0">
                        <div className="clearfix" />
                        <div className="mt-3 mb-5">
                            <>
                                <p className='mb-0 mt-3 text-center'>We are having trouble processing your order request. There can be various reasons as to why, please reach out to your local Sales Representative (indicated under My Contacts, on your Dashboard).</p>
                            </>

                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-sm btn-primary" data-dismiss="modal"
                                onClick={() => {
                                    setIsPaymentBlocked('close')
                                    SetStatus(false)
                                }}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ContactUsPlaceOrderPopup;